import React from 'react';
import TranslationFlow from './TranslationFlow';

const Dashboard = () => {
  return <TranslationFlow />;
};

export default Dashboard;